import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getAcceptedPaymentMethodsQueryFn } from './queryFn/getAcceptedPaymentMethods.query';
import { getDealerIntentQueryFn } from './queryFn/getDealerIntent.query';
import { listOffersHttpQueryFn } from './queryFn/listOffersHttp.query';
export const DealerQueriesConfig = createQueriesConfig({
  listOffers: {
    queryFn: listOffersHttpQueryFn
  },
  getDealerIntent: {
    queryFn: getDealerIntentQueryFn
  },
  getAcceptedPaymentMethods: {
    queryFn: getAcceptedPaymentMethodsQueryFn
  }
});
//# sourceMappingURL=dealer.queries.js.map